import { useEffect } from "react";
import { useRunningProjectSimQuery } from "~/gql/generated";
import { useAppDispatch, useAppSelector } from "~/redux/store";
import { setSimulationInProgress } from "../../projectsCommon/projectSlice";

const POLLING_INTERVAL = 5000;

export function useProjectRunningSimulationPolling({
  projectId,
}: {
  projectId: string;
}) {
  const { simulationInProgress } = useAppSelector((state) => state.project);
  const dispatch = useAppDispatch();

  const { isError } = useRunningProjectSimQuery(
    { project_id: projectId },
    {
      pollingInterval: simulationInProgress ? POLLING_INTERVAL : undefined,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (isError) {
      dispatch(setSimulationInProgress(null));
    }
  }, [isError]);

  return { simulationInProgress };
}
